import PropTypes from "prop-types";
import { Fonts } from "yuka";

const EMPTY_VALUE_PLACEHOLDER = <Fonts.Body1theme50>--</Fonts.Body1theme50>;

const FundingRoundEventCellRenderer = ({ value: fundingRound }) => {
  return fundingRound.event || EMPTY_VALUE_PLACEHOLDER;
};

FundingRoundEventCellRenderer.propTypes = {
  value: PropTypes.shape({
    event: PropTypes.string,
    parent_funding_round: PropTypes.shape({}),
  }).isRequired,
};

export default FundingRoundEventCellRenderer;
